define('ProductPriceBadge.EntryPoint', [], function () {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      if (layout) {
        layout.addToViewContextDefinition(
          'ProductViews.Price.View',
          'showSavingsBadge',
          'boolean',
          function (context) {
            var item = context.model.item;
            if (!item) { return false; }
            var salePrice = item.keyMapping_comparePriceAgainst;
            var originalPrice = item.pricelevel1;
            return !!(salePrice && originalPrice && originalPrice > salePrice);
          }
        );

        layout.addToViewContextDefinition(
          'ProductViews.Price.View',
          'savingsPercent',
          'number',
          function (context) {
            var item = context.model.item;
            if (!item) { return 0; }
            var salePrice = item.keyMapping_comparePriceAgainst;
            var originalPrice = item.pricelevel1;
            if (!salePrice || !originalPrice || originalPrice <= salePrice) { return 0; }
            return Math.round(((originalPrice - salePrice) / originalPrice) * 100);
          }
        );
      }
    }
  };
});
